import { useContext } from 'react';

import FocusRegion from './FocusRegion';

export default function useFocusRegion() {
  return useContext(FocusRegion.Context);
}
